import {
  IntegrationChannelType,
  IntegrationChannelViewFragment,
} from 'generated/graphql';

export const isZapierIntegration = (channel: IntegrationChannelViewFragment) =>
  channel.type === IntegrationChannelType.Webhook &&
  channel.displayName === 'Zapier';
